import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../css/components/controls/HrnbDatePicker.css";

export default function HrnbDateTimePicker({
                                               label,
                                               value,
                                               onChange,
                                               minDate,
                                               maxDate,
                                               disabled = false,
                                               className = "",
                                               error = "",
                                               hint = "",
                                               placeholder = "Выберите дату и время",
                                               required = false,
                                               ...props
                                           }) {
    const handleChange = (date) => {
        if (date) {
            // Форматируем дату в локальном формате yyyy-MM-dd HH:mm
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            onChange(`${year}-${month}-${day} ${hours}:${minutes}`);
        } else {
            onChange("");
        }
    };

    const formattedValue = value ? new Date(value) : null;

    return (
        <div className={`hrnb-datepicker-wrap ${className} ${disabled ? "hrnb-datepicker--disabled" : ""}`}>
            {label && <label className="hrnb-datepicker__label">{label}</label>}
            <ReactDatePicker
                selected={formattedValue}
                onChange={handleChange}
                minDate={minDate ? new Date(minDate) : undefined}
                maxDate={maxDate ? new Date(maxDate) : undefined}
                disabled={disabled}
                placeholderText={placeholder}
                showTimeSelect
                dateFormat="yyyy-MM-dd HH:mm"
                timeFormat="HH:mm"
                required={required}
                className={`hrnb-datepicker__input${error ? " hrnb-datepicker__input--error" : ""}`}
                calendarClassName="hrnb-datepicker__calendar"
                popperClassName="hrnb-datepicker__popper"
                {...props}
            />
            {error
                ? <div className="hrnb-datepicker__error">{error}</div>
                : hint && <div className="hrnb-datepicker__hint">{hint}</div>
            }
        </div>
    );
}
